import { FilterType } from "@/shared/enums/Filter.enum";
import { FilterConfig, PanelTab } from "@/shared/types";

const filters: FilterConfig[] = [
	{
		id: "companyName",
		name: "Company Name",
		description: "company_name",
		placeholder: "enter_company_name",
		items: [],
		type: FilterType.INPUT,
	},
	{
		id: "status",
		name: "status",
		description: "status",
		items: [
			{
				id: "active",
				label: "active",
			},
			{
				id: "inactive",
				label: "inactive",
			},
			{
				id: "churned",
				label: "churned",
			},
		],
	},
];

const panels: PanelTab[] = [{ title: "All companies " }, { title: "Active" }, { title: "Chruned" }];

const companiesColumns: string[] = [
	"company",
	"activeEmployees",
	"keyAccountManager",
	"billing",
	"payments",
	"createdAt",
	"status",
];

export { companiesColumns, panels, filters };
